import { getDeliveryDescriptionData } from '@entities/Delivery';
import { useAppSelector } from '@redux/hooks';
import classNames from 'classnames';
import { FC } from 'react';
import { DeliveryDescription, TypeDelivery } from '../../module/types/deliverySchema';
import { DeliveryByTransportCompany } from './DeliveryByTransportCompany';
import { DeliveryCourierDelivery } from './DeliveryCourierDelivery';
import { DeliveryPickup } from './DeliveryPickup';
import { DeliveryDescriptionBlocksTypeProps } from './TypeProps';
import { TitleBlock } from '@app/widgets/ui/Product/WrapperTabs/ui';

import styles from './DeliveryDescriptionBlocks.module.scss';

const deliveryOrder = {
  [TypeDelivery.Pickup]: 1,
  [TypeDelivery.CourierDelivery]: 2,
  [TypeDelivery.DeliveryByTransportCompany]: 3,
};

const DeliveryComponent = (delivery: DeliveryDescription): JSX.Element => {
  switch (delivery.code) {
    case TypeDelivery.Pickup:
      return <DeliveryPickup {...delivery} />;
    case TypeDelivery.CourierDelivery:
      return <DeliveryCourierDelivery {...delivery} />;
    case TypeDelivery.DeliveryByTransportCompany:
      return <DeliveryByTransportCompany {...delivery} />;
    default:
      return <></>;
  }
};

export const DeliveryDescriptionBlocks: FC<DeliveryDescriptionBlocksTypeProps> = ({ className }) => {
  const listDelivery = useAppSelector(getDeliveryDescriptionData);

  const sortedDeliveries = listDelivery
    ?.filter(delivery => delivery.description)
    ?.sort((a, b) => {
      return (deliveryOrder[a.code] || 0) - (deliveryOrder[b.code] || 0);
    });

  return (
    <div className={classNames(styles.WrapperDeliveryDescriptionBlocks, className)}>
      <TitleBlock>Как купить</TitleBlock>
      {sortedDeliveries?.map(delivery => <DeliveryComponent key={delivery.code} {...delivery} />)}
    </div>
  );
};
